import { CallForActionButton, CallForActionButtonTooltip } from 'components/buttons/CallForActionButton';
import { t } from 'utils/getTranslations';
import TrackingGlyph from './TrackingGlyph';

type Props = {
    onClick: () => void;
    disabled?: boolean;
    /** Whether it took the other button's place, which its glyph then cross-fades from. */
    swapped?: boolean;
};

const StartTrackingIconButton = ({ onClick, disabled, swapped }: Props): JSX.Element => {
    return (
        <CallForActionButtonTooltip title={t('timecards.continue')}>
            <CallForActionButton
                variant="contained"
                color="info"
                shape="rounded"
                aria-label={t('timecards.continue')}
                disabled={disabled}
                className="bg-info text-primary-foreground"
                onClick={onClick}
            >
                <TrackingGlyph tracking={false} swapped={swapped} />
            </CallForActionButton>
        </CallForActionButtonTooltip>
    );
};

export default StartTrackingIconButton;
